/** Смещения в textContent корня ↔ DOM Range. Нужно, чтобы общее выделение
 * в markdown-условии не зависело от дерева тегов (таблицы, формулы, списки). */

export function rangeToOffsets(root, range) {
  if (!root || !range) return null;
  try {
    if (!root.contains(range.startContainer) || !root.contains(range.endContainer)) {
      return null;
    }
    const pre = document.createRange();
    pre.selectNodeContents(root);
    pre.setEnd(range.startContainer, range.startOffset);
    const start = pre.toString().length;
    const end = start + range.toString().length;
    if (start === end) return { start, end };
    return start <= end ? { start, end } : { start: end, end: start };
  } catch {
    return null;
  }
}

export function offsetsToRange(root, start, end) {
  if (!root || typeof start !== 'number' || typeof end !== 'number' || start >= end) {
    return null;
  }
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let pos = 0;
  let startNode = null;
  let startOff = 0;
  let endNode = null;
  let endOff = 0;
  let node = walker.nextNode();
  while (node) {
    const len = node.nodeValue.length;
    if (startNode == null && pos + len >= start) {
      startNode = node;
      startOff = start - pos;
    }
    if (endNode == null && pos + len >= end) {
      endNode = node;
      endOff = end - pos;
      break;
    }
    pos += len;
    node = walker.nextNode();
  }
  if (!startNode) return null;
  if (!endNode) {
    endNode = startNode;
    endOff = startNode.nodeValue.length;
  }
  try {
    const range = document.createRange();
    range.setStart(startNode, clampOffset(startNode, startOff));
    range.setEnd(endNode, clampOffset(endNode, endOff));
    return range.collapsed ? null : range;
  } catch {
    return null;
  }
}

function clampOffset(node, offset) {
  const max = node.nodeValue ? node.nodeValue.length : 0;
  return Math.max(0, Math.min(offset, max));
}

/** Прямоугольники выделения относительно padding-box корня (для absolute overlay). */
export function rangeRectsRelativeTo(root, range) {
  if (!root || !range) return [];
  const origin = root.getBoundingClientRect();
  return Array.from(range.getClientRects())
    .filter((r) => r.width > 0 && r.height > 0)
    .map((r) => ({
      top: r.top - origin.top,
      left: r.left - origin.left,
      width: r.width,
      height: r.height,
    }));
}
